import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/heylloyd/Header';
import { HeroSection } from '../components/heylloyd/HeroSection';
import { StepSection } from '../components/heylloyd/StepSection';
import { LloydCard } from '../components/heylloyd/LloydCard';
import { DecisionGuide } from '../components/heylloyd/DecisionGuide';
import { FinalCTA } from '../components/heylloyd/FinalCTA';
import { Download, Monitor, Bot, Check, X } from 'lucide-react';
import { Button } from '../components/ui/Button';
// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function HeyLloydCustomsPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);
    window.fbq('init', '1465116804947067');
    window.fbq('track', 'PageView');
  }, []);
  const handleCTAClick = (buttonName: string) => {
    // Fire AddToCart event when CTA button is clicked
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: buttonName,
        content_category: 'HeyLloyd Custom'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-cyan-100 selection:text-cyan-900" data-id="element-2506" data-mp="1c4ex1watljjg">
      {/* Meta Pixel noscript */}
      <noscript data-id="element-2507" data-mp="4qurlpkv5knc">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1465116804947067&ev=PageView&noscript=1" data-id="element-2508" data-mp="4r4fn7mclhqe" />
      </noscript>

      <Header data-id="element-2509" data-mp="8q3jsq099ags" />
      <div id="hero" data-id="element-2510" data-mp="drj3oeqp5axl">
        <HeroSection data-id="element-2511" data-mp="drarkp2ee9ng" />
      </div>
      {/* PASO 1 */}
      <div id="paso-1" data-id="element-2512" data-mp="dpg9rjmfaxnl">
        <StepSection stepNumber="1" title="Instala y abre HeyLloyd en tu computadora" data-id="element-2513" data-mp="ihzleb1jvipr">
          <p className="text-lg md:text-xl text-slate-600 mb-6 md:mb-8" data-id="element-2514" data-mp="nhcg1hynxu2w">
            Primero, vamos a convertir tu computadora en una computadora con IA
            integrada. Sigue estos pasos sencillos:
          </p>
          <div className="mb-8 md:mb-10" data-id="element-2515" data-mp="whisr1mjeq10">
            <a href="https://app.heylloyd.io/web-checkout" target="_blank" rel="noopener noreferrer" onClick={() => handleCTAClick('Descargar HeyLloyd')} data-id="element-2516" data-mp="wik65cr0zolw">
              <Button variant="cyan" size="lg" className="w-full md:w-auto shadow-lg hover:shadow-xl" leftIcon={<Download className="w-5 h-5" data-id="element-2518" data-mp="337yni3vwyxkg" />} data-id="element-2517" data-mp="2y9x57l6bb2a1">
                Descargar HeyLloyd
              </Button>
            </a>
          </div>
          <div className="space-y-4 md:space-y-6" data-id="element-2519" data-mp="2vqk0zui8p124">
            <div className="flex gap-3 md:gap-4" data-id="element-2520" data-mp="2qyiruhgdbqgb">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2521" data-mp="2qwo999skkafe">
                1
              </div>
              <div data-id="element-2522" data-mp="2h1nvo57ki257">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2523" data-mp="2gy02x89y5jrj">
                  Haz clic en "Get for Mac" o "Get for Windows"
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2524" data-mp="39q1tajuquwg8">
                  Esto descargará el archivo de instalación de HeyLloyd en tu
                  computadora (normalmente en la carpeta "Descargas").
                </p>
              </div>
            </div>
            <div className="flex gap-3 md:gap-4" data-id="element-2525" data-mp="1tb0cgns7bq3c">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2526" data-mp="1t8e2khhu8yhy">
                2
              </div>
              <div data-id="element-2527" data-mp="3d4a2ltq6clc9">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2528" data-mp="3hwbdpcblw60p">
                  Abre el archivo descargado
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2529" data-mp="338qbdkmk2atu">
                  Haz doble clic en el archivo. Se abrirá el instalador de
                  HeyLloyd. Sigue las instrucciones en pantalla hasta que
                  termine.
                </p>
              </div>
            </div>
            <div className="flex gap-3 md:gap-4" data-id="element-2530" data-mp="4ogplov1xrzy">
              <div className="flex-shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-cyan-100 text-cyan-700 flex items-center justify-center font-bold text-sm" data-id="element-2531" data-mp="3mveiqwrl6c8o">
                3
              </div>
              <div data-id="element-2532" data-mp="2bg93yue6kn8p">
                <h4 className="font-bold text-slate-900 mb-1 text-sm md:text-base" data-id="element-2533" data-mp="2bfpy4c1t1pb1">
                  Haz clic en "Start Lloyd"
                </h4>
                <p className="text-slate-600 text-sm md:text-base" data-id="element-2534" data-mp="2fj5r8yeo17iz">
                  Cuando la instalación finalice, selecciona "Start Lloyd".
                  Verás una capa transparente sobre tu pantalla: ese es
                  HeyLloyd, listo para ayudarte.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6 md:mt-8 p-3 md:p-4 bg-blue-50 border border-blue-100 rounded-lg text-blue-800 text-xs md:text-sm" data-id="element-2535" data-mp="2cxo8lvv2iowj">
            <strong data-id="element-2536" data-mp="1p8vm0q0c5tel">Nota:</strong> Si en algún momento te pierdes, vuelve al
            video de arriba y mira exactamente cómo lo hago en mi pantalla.
          </div>
        </StepSection>
      </div>
      {/* PASO 2 */}
      <div id="paso-2" data-id="element-2537" data-mp="1yz6pkbg3y0ky">
        <StepSection stepNumber="2" title="Usa HeyLloyd mientras trabajas" bgColor="gray" data-id="element-2538" data-mp="1yzq4rkediava">
          <p className="text-lg md:text-xl text-slate-600 mb-4 md:mb-6" data-id="element-2539" data-mp="1u4u2lrffa74g">
            HeyLloyd es una superposición de escritorio transparente que se
            coloca sobre tu pantalla. Eso significa que:
          </p>
          <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8" data-id="element-2540" data-mp="1r6dflybq4jmt">
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-2541" data-mp="1r4ar5iq7yyk7">
              <Monitor className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-2542" data-mp="1v65ne8tamlr4" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-2543" data-mp="1zz8lmu90mjdn">
                Tu pantalla de siempre
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-2544" data-mp="187ss0g91jwdx">
                Ves tu computadora como siempre, pero ahora con IA integrada.
              </p>
            </div>
            <div className="bg-white p-4 md:p-6 rounded-xl border border-slate-200 shadow-sm" data-id="element-2545" data-mp="1caxre9xtrhyc">
              <Bot className="w-7 h-7 md:w-8 md:h-8 text-cyan-600 mb-3 md:mb-4" data-id="element-2546" data-mp="1haab4lteg8wp" />
              <h4 className="font-bold text-slate-900 mb-1 md:mb-2 text-sm md:text-base" data-id="element-2547" data-mp="1m8lmx2398thk">
                Contexto automático
              </h4>
              <p className="text-slate-600 text-xs md:text-sm" data-id="element-2548" data-mp="2xm7e0ssod55q">
                HeyLloyd ve lo que tú ves, entiende el contexto y te ayuda sin
                que tengas que cambiar de pestaña.
              </p>
            </div>
          </div>
          <ul className="space-y-2 md:space-y-3 mb-4 md:mb-6" data-id="element-2549" data-mp="h0j4i86up325">
            {['Abre cualquier aplicación o página donde estés trabajando.', 'Activa HeyLloyd (como viste en el video).', 'Pídele lo que necesites: HeyLloyd ya entiende qué hay en tu pantalla.'].map((item, i) => <li key={i} className="flex items-start text-slate-700 text-sm md:text-base" data-id="element-2550" data-mp="395nb0wf0haa" data-mpi={i}>
                <Check className="w-4 h-4 md:w-5 md:h-5 text-cyan-500 mr-2 md:mr-3 flex-shrink-0 mt-0.5" data-id="element-2551" data-mp="3uee2x4mvg7t3" />
                <span data-id="element-2552" data-mp="3pfaynmepu5m6">{item}</span>
              </li>)}
          </ul>
          <p className="font-medium text-slate-900 italic border-l-4 border-cyan-500 pl-3 md:pl-4 text-sm md:text-base" data-id="element-2553" data-mp="3phnlodzbz663">
            "Piensa en HeyLloyd como la capa de IA que le faltaba a tu
            computadora."
          </p>
        </StepSection>
      </div>
      {/* PASO 3 */}
      <div id="paso-3" data-id="element-2554" data-mp="1ina34csfliwf">
        <StepSection stepNumber="3" title="Elige y usa tus Lloyds personalizados" data-id="element-2555" data-mp="rk0sp8n7p1bh">
          <p className="text-slate-600 mb-4 md:mb-6 text-sm md:text-base" data-id="element-2556" data-mp="rmd5z8i0yni7">
            Dentro de HeyLloyd puedes usar <strong data-id="element-2557" data-mp="irp0picg95te">Custom Lloyds</strong>: son
            bots especializados para tareas concretas (copy, investigación,
            etc.). Cada Lloyd está pre-configurado para guiarte paso a paso.
          </p>
          <div className="bg-slate-50 rounded-xl p-4 md:p-6 border border-slate-200 mb-6 md:mb-8" data-id="element-2558" data-mp="8tspyrnfccvt">
            <h4 className="font-bold text-slate-900 mb-3 md:mb-4 text-sm md:text-base" data-id="element-2559" data-mp="dscgz6gvkev1">
              Cómo funciona:
            </h4>
            <ol className="list-decimal list-inside space-y-1.5 md:space-y-2 text-slate-700 text-sm md:text-base" data-id="element-2560" data-mp="3vzk0i32d989z">
              <li data-id="element-2561" data-mp="3uy6roljomb6">Descargas un archivo de Lloyd en tu computadora.</li>
              <li data-id="element-2562" data-mp="1u7x6rtr3az9t">Abres ese archivo con HeyLloyd.</li>
              <li data-id="element-2563" data-mp="1u51ae9uw4inh">
                HeyLloyd carga ese bot y empieza a darte instrucciones claras.
              </li>
            </ol>
          </div>
          <div className="space-y-1.5 md:space-y-2" data-id="element-2564" data-mp="3irjfxszdfck8">
            <h4 className="font-bold text-slate-900 text-sm md:text-base" data-id="element-2565" data-mp="3eowldkbbfdjc">
              Beneficios:
            </h4>
            <ul className="space-y-1.5 md:space-y-2 text-slate-600 text-sm md:text-base" data-id="element-2566" data-mp="3sg1gqa7nhjnv">
              <li className="flex items-center" data-id="element-2567" data-mp="3npurc85bdv4k">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2568" data-mp="3no1jwqmvn6vi" />
                No tienes que saber de prompts.
              </li>
              <li className="flex items-center" data-id="element-2569" data-mp="1a09ydupxc81">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2570" data-mp="198gp9olfqkx" />
                No tienes que diseñar nada desde cero.
              </li>
              <li className="flex items-center" data-id="element-2571" data-mp="aay484fcu5df">
                <span className="w-1.5 h-1.5 bg-blue-400 rounded-full mr-2" data-id="element-2572" data-mp="ab7w5xjymmlr" />
                Solo eliges, abres y sigues las indicaciones.
              </li>
            </ul>
          </div>
        </StepSection>
      </div>
      {/* GALLERY */}
      <section id="gallery" className="py-12 md:py-20 bg-slate-50 border-t border-slate-200" data-id="element-2573" data-mp="2kzfousbhrtu2">
        <div className="container mx-auto px-4 max-w-6xl" data-id="element-2574" data-mp="2g0chh181hbix">
          <div className="text-center mb-10 md:mb-16" data-id="element-2575" data-mp="2fyt0t9ih0ygm">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-3 md:mb-4 px-2" data-id="element-2576" data-mp="2byhkua11zmbh">
              Custom Lloyds Exclusivos
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto text-sm md:text-base px-2" data-id="element-2577" data-mp="271r2th5ougnf">
              Lloyds especializados disponibles solo para estudiantes de 48 Hrs
              AI Cash Machine Academy
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-8 md:mb-12" data-id="element-2578" data-mp="2uxd7n0al0yfa">
            <LloydCard title="AI Product Builder" subtitle="Construcción de productos con IA" description="Tu asistente completo para crear productos digitales desde cero. HeyLloyd te guía en cada paso: desde la idea inicial hasta el lanzamiento, ayudándote a construir productos profesionales sin experiencia técnica." imageSrc="https://cdn.magicpatterns.com/uploads/q4SLHaHdAivvR2DiTEBLB4/hf_20260116_225721_4dc7f3c1-48e8-4206-b7a5-3ddf70d36f02.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('AI Product Builder')} data-id="element-2579" data-mp="2pys8l472gksf" />
            <LloydCard title="Ebook Writer" subtitle="Escritura de ebooks" description="Perfecto para crear ebooks completos desde cero. HeyLloyd te guiará en la estructura, capítulos, y contenido para que escribas tu ebook paso a paso, directamente en tu pantalla. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/wN17SfcSENBgcMNUuXCiU3/hf_20260117_000004_e51b1569-2f2c-4476-a8b1-16bd3b0c149a.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Ebook Writer')} data-id="element-2580" data-mp="7u2b2iofyd7e" />
            <LloydCard title="Ebook Cover Designer" subtitle="Diseño de portadas" description="Especializado en crear portadas profesionales y atractivas para tus ebooks. HeyLloyd te guía en el diseño visual, tipografía y elementos gráficos para que tu ebook destaque y atraiga lectores. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/b14aCxx1KMK9dt11wkxhEQ/hf_20260117_000043_0d6fe8d3-9889-4c99-9732-0c2d3c868689.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Ebook Cover Designer')} data-id="element-2581" data-mp="2wl2wgv9qk7ai" />
            <LloydCard title="Meta Ads Decision Engine" subtitle="Optimización de anuncios" description="Motor de decisiones para tus campañas de Meta Ads. HeyLloyd te ayuda a analizar, optimizar y tomar decisiones estratégicas sobre tus anuncios de Facebook e Instagram en tiempo real. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/fP5h2DKoU4svvGzbLMWbJu/hf_20260117_000127_6ac5b4e1-6a69-4cc2-a2ec-321b5ded1fb4.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Meta Ads Decision Engine')} data-id="element-2582" data-mp="3k8b078rin8af" />
            <LloydCard title="The Viral PDF Lab" subtitle="PDFs virales" description="Laboratorio especializado en crear PDFs que se comparten masivamente. Ideal para lead magnets, recursos descargables y contenido que tu audiencia querrá compartir una y otra vez. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/2tNEnEu5UE3okfUmab7edk/hf_20260117_000148_2c4e2d0b-d01f-4fc2-9a59-f64c2f15a038.png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('The Viral PDF Lab')} data-id="element-2583" data-mp="3nskvaqsehxvd" />
            <LloydCard title="Sales Letter Weapon" subtitle="Cartas de ventas" description="Tu arma secreta para crear sales letters que convierten. HeyLloyd te ayudará a estructurar y escribir cartas de ventas persuasivas que generan resultados reales. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/5kGWUnrmKDQYXzDLEYEM4t/hf_20260116_235421_4c8d470f-9735-4fb6-a872-9980f950cb75_(1).png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('Sales Letter Weapon')} data-id="element-2584" data-mp="dd5igp0ir37e" />
            <LloydCard title="AI Business In A Box" subtitle="Negocio completo con IA" description="Sistema completo para lanzar tu negocio digital con IA. Incluye estrategia, herramientas, y procesos listos para implementar. Todo lo que necesitas para empezar tu negocio en un solo lugar. Only Available For Students Of 48 Hrs AI Cash Machine Academy - To unlock, become a member." imageSrc="https://cdn.magicpatterns.com/uploads/vZRGjeWsMWUmgY2TH7PWjr/hf_20260117_000209_aba255e4-f91b-4bed-b0d8-12b4f199acaf_(1).png" url="https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5" buttonText="Obtener Acceso Ahora" buttonIcon="download" badge="FREE - Value $97" onButtonClick={() => handleCTAClick('AI Business In A Box')} data-id="element-2585" data-mp="3ct26er5cavo4" />
          </div>
          <div className="text-center bg-white p-4 md:p-6 rounded-xl border border-slate-200 max-w-2xl mx-auto shadow-sm" data-id="element-2586" data-mp="1ijdh47xe17kb">
            <h4 className="font-bold text-slate-900 mb-2 flex items-center justify-center" data-id="element-2587" data-mp="1ndrh6nmzw2vb">
              <Download className="w-4 h-4 mr-2 text-cyan-600" data-id="element-2588" data-mp="pu6jdb5rcm04" />
              Acceso Exclusivo para Miembros
            </h4>
            <p className="text-sm text-slate-600" data-id="element-2589" data-mp="muo7r2veoxby">
              Estos Custom Lloyds están disponibles únicamente para estudiantes
              de 48 Hrs AI Cash Machine Academy. Conviértete en miembro para
              desbloquear acceso completo.
            </p>
          </div>
        </div>
      </section>
      <DecisionGuide data-id="element-2590" data-mp="rlo1y0d551ar" />
      <FinalCTA onCTAClick={() => handleCTAClick('Empezar ahora con HeyLloyd - Final CTA')} data-id="element-2591" data-mp="rmfoklorfoow" />

      {/* Footer */}
      <footer className="w-full relative z-10 bg-slate-900 border-t border-slate-800" data-id="element-2592" data-mp="3wlh6jn7msc1">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-2593" data-mp="3w0nuxmxxyzzg">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-2594" data-mp="dusr4ij30a4j">
            <p data-id="element-2595" data-mp="8tvaiadpzo55">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-2596" data-mp="2y6wf3eaxrsik">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-2597" data-mp="3h3o3211favsy">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-2598" data-mp="29kbu0nktez32">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-2599" data-mp="1zquvj69qgvt2">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-2600" data-mp="2si4tth056sw8">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-700" data-id="element-2601" data-mp="2iixguuxbl09n">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-2602" data-mp="2eidkvuohg2p3">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-2603" data-mp="1763blnbp37yk">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-2604" data-mp="1325c3bigjv4z">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-2605" data-mp="3isotbp6jv0c4">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2606" data-mp="3nqqdkdfpp5p6">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-2607" data-mp="1bnnhhrojyd4">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-2608" data-mp="1b47w7pi5m29">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-2609" data-mp="f9vjnngw6vn8">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2610" data-mp="2c5jkpwzt50h6">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2611" data-mp="20wup1xz2brfw">
              <X className="w-6 h-6" data-id="element-2612" data-mp="25ss666i5h1tq" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2613" data-mp="2asy1pxrjj8h3">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2614" data-mp="2fm0nhjq2tdmq">
              <p data-id="element-2615" data-mp="2jlri5yiq4dwj">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2616" data-mp="2tls7q276rq96">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-2617" data-mp="2yhhaeeei5n9p">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2618" data-mp="3hgbywri0bgnn">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2619" data-mp="3co0zrqv3byw5">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2620" data-mp="33mks3qvnuavm">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2621" data-mp="75kewar8ddn">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2622" data-mp="2fz34m7jfhyyg">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2623" data-mp="2ayf5eyl1qbt5">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2624" data-mp="23gqsj0if064l">
                5. Modificaciones
              </h3>
              <p data-id="element-2625" data-mp="28e93sxjwmxfr">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2626" data-mp="1kppvii0uukno">Contacto</h3>
              <p data-id="element-2627" data-mp="1knmul2y5z746">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2628" data-mp="1orktpdnhohx8">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2629" data-mp="w5w5k45q5puo">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2630" data-mp="r7l0e6qdk3is">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-2631" data-mp="113o9jwjn92f8">
              <X className="w-6 h-6" data-id="element-2632" data-mp="1f1vzhki9j3gw" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2633" data-mp="1a5dy8um55n9b">
              Política de Privacidad
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2634" data-mp="1osyzsk3dbef4">
              <p data-id="element-2635" data-mp="1juxlsdksu5ai">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2636" data-mp="3nbbyhs9p7lsw">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-2637" data-mp="3s9n9457ti0c6">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2638" data-mp="wj4n1xb1huz">
                <li data-id="element-2639" data-mp="5tstafcvdphr">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2640" data-mp="34cpxede6luoz">Información de registro del evento</li>
                <li data-id="element-2641" data-mp="34eatw8k23nph">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2642" data-mp="39cccksdkll0f">
                2. Uso de la Información
              </h3>
              <p data-id="element-2643" data-mp="3ecql0bj32wyz">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2644" data-mp="3ichh8urdq5aw">
                <li data-id="element-2645" data-mp="tkf063b513q6">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2646" data-mp="xlgzek521fs5">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2647" data-mp="xnuw0xfdv01t">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2648" data-mp="2i2rcfgoayevj">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2649" data-mp="2e27dq8o2z37a">
                3. Compartir Información
              </h3>
              <p data-id="element-2650" data-mp="29afvqmizq5sr">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2651" data-mp="1udf22dh8o0rn">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2652" data-mp="1qd4z79oqtqh0">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2653" data-mp="3fs2t0a4bc794">
                5. Tus Derechos
              </h3>
              <p data-id="element-2654" data-mp="2qs4k9tg1p77">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2655" data-mp="3pvq4282e98xf">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2656" data-mp="3usgkiwi426jd">6. Cookies</h3>
              <p data-id="element-2657" data-mp="mfsspvshxuxi">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2658" data-mp="cgbpdl0pvt4p">Contacto</h3>
              <p data-id="element-2659" data-mp="hevefualxl1a">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-cyan-400 hover:text-cyan-300" data-id="element-2660" data-mp="2x612ntlrv6va">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}